export default __webpack_public_path__ + "static/media/image_HitSelectDrive.430422d1.svg";